import './question.scss';
import Logo from '../../assets/logo-small.svg';
import ILLUSTRATION_ANSWERS from '../../assets/illustration-answers.png';
import ICON_BONUS from '../../assets/icon-bonus.png';
import Button from '../../components/button/button';
import ModalTeamChallenge from '../../components/modal-team-challenge/ModalTeamChallenge';
import { useState, useEffect, useRef } from 'react';
import { useLocation } from "react-router-dom";
import { SERVER } from '../../env';
import moment from 'moment';
import TeamChallengeService from '../../services/team-challenge-service';
import LocalStorage from '../../services/local-storage';
import { TEAM, SESSION } from '../../constants';
import TranslateService from '../../services/translate-service';
import ModalTeamChallengeEnd from '../../components/modal-team-challenge-end/modal-team-challenge-end';

export default function Question() {

    const { state } = useLocation();

    const timerBonus = useRef(null);
    const iconBonus = useRef(null);

    const [team] = useState(LocalStorage.get(TEAM));
    const [session] = useState(LocalStorage.get(SESSION));


    const [TIME_LIMIT_QUICK_ANSWER] = useState(10);
    const [POINTS_QUICK_ANSWER] = useState(2);
    const [POINTS_CORRECT_ANSWER] = useState(10);

    const [counterBack, setCounterBack] = useState(3);
    const [isPreparing, setIsPreparing] = useState(true);
    const [questions, setQuestions] = useState([]);
    const [currentQuestion, setCurrentQuestion] = useState(null);
    const [myAnswer, setMyAnswer] = useState(null);
    const [stats, setStats] = useState([]);
    const [time, setTime] = useState(0);
    const [responseRound, setResponseRound] = useState(null);


    useEffect(() => {
        const interval = setInterval(() => {
            setCounterBack(counterBack => {

                if (counterBack === 0) {
                    clearInterval(interval)
                    setIsPreparing(false)
                    return 0;
                } else {
                    return counterBack - 1
                }
            })

        }, 1000);

        return () => clearInterval(interval);
    }, []);    

    useEffect(() => {
        if (!isPreparing) {
            let questionsTMP = state.questions.sort(() => 0.5 - Math.random());

            let question = questionsTMP.shift();
            let options = [
                question.opcion1,
                question.opcion2,
                question.opcion3,
                question.opcion4,
            ];

            question.options = options.sort(() => 0.5 - Math.random());
            setCurrentQuestion(question);
            setQuestions(questionsTMP);
        }
    }, [isPreparing]);

    useEffect(() => {
        if (currentQuestion) {
            initTimer()
            setTime(moment())
        }
    }, [currentQuestion]);

    const preparing = () => {

        if (!isPreparing) return null;

        return (
            <div className='text-center pb-14'>
                <img src={ILLUSTRATION_ANSWERS} alt="" className='m-auto' />
                <h1 className='heading-h1 !text-white mb-5'>{TranslateService.get('teamChallenge.challenge.init.title')}</h1>
                <p className='font-family-montserrat uppercase  text-white text-center' dangerouslySetInnerHTML={{ __html: TranslateService.getAndReplace('teamChallenge.challenge.init.subtitle', { team: team.nombre}) }}></p>

                <h1 className='heading-h1 !text-white !text-[64px] mt-40 '>{counterBack}</h1>
            </div>
        )
    }

    const handleAnswer = (index, option) => {
        if (myAnswer) return;
        
        timerBonus.current.style.animationPlayState = 'paused';
        iconBonus.current.style.animationPlayState = 'paused';

        let timeEnd = moment();
        let diff = +(timeEnd.diff(time, 'seconds', true).toFixed(2));
        option.diff = diff + 1;
        option.index = index;
        option.points = option.esCorrecta ? POINTS_CORRECT_ANSWER : 0;
        option.extraPoints = option.esCorrecta ? calculateExtraPoints(diff) : 0;
        
        let statsTMP = [...stats];
        statsTMP.push( {
            pregunta: currentQuestion._id,
            tiempo: option.diff,
            puntos: option.points + option.extraPoints,
            esCorrecta: option.esCorrecta
        });
        
        setStats(statsTMP);
        setMyAnswer(option);
    }

    const calculateExtraPoints = (diff) => {
        const chunk = TIME_LIMIT_QUICK_ANSWER / 4;

        if (diff >= 0 && diff < chunk) {
            return POINTS_QUICK_ANSWER * 4;
        }

        if (diff >= chunk && diff < chunk * 2) {
            return POINTS_QUICK_ANSWER * 3;
        }

        if (diff >= chunk * 2 && diff < chunk * 3) {
            return POINTS_QUICK_ANSWER * 2;
        }

        if (diff >= chunk * 3 && diff < chunk * 4) {
            return POINTS_QUICK_ANSWER;
        }

        return 0;

    }

    const nextQuestion = () => {
       
        let questionsTMP = [...questions];
        
        if(!questionsTMP.length) {
            return saveStats();
        }

        let question = questionsTMP.shift();
        let options = [
            question.opcion1,
            question.opcion2,
            question.opcion3,
            question.opcion4,
        ];

        question.options = options.sort(() => 0.5 - Math.random());

        setCurrentQuestion(question);
        setQuestions(questionsTMP);
        setMyAnswer(null);

        initTimer()
    }

    const formatResponseTime = () => {
        if(!myAnswer || !myAnswer.diff ) return 0;

        let minutes = myAnswer.diff / 60;

        if(minutes > 1) {
            return `${minutes.toFixed(2)} M.`;
        }

        return `${myAnswer.diff} S.`;
    }

    const saveStats = async () => {
        try {
            await TeamChallengeService.save(team.area._id, team._id, session._id, stats);
            const response = await TeamChallengeService.getStatus(team.area._id, team._id, session._id);

            setResponseRound({
                round: stats,
                status: response,
                isOpen: true
            })
        } catch (error) {
            console.log(error)
        }
    }

    const initTimer = () => {
        if(!timerBonus.current || !iconBonus.current) return ;

        timerBonus.current.style.animationPlayState = '';
        timerBonus.current.style.animation = '';
        
        iconBonus.current.style.animationPlayState = '';
        iconBonus.current.style.animation = '';

        setTimeout( () => {
            timerBonus.current.style.animation = 'countdown ' + TIME_LIMIT_QUICK_ANSWER + 's linear  forwards';
            iconBonus.current.style.animation = 'hideIconBonus ' + TIME_LIMIT_QUICK_ANSWER + 's linear ';
        })
    }

    return (
        <>
            <ModalTeamChallenge isOpen={responseRound?.isOpen } round={responseRound?.round} status={responseRound?.status} />
            
            <div className='question'>
                <div className="container mx-auto px-4 pb-[150px]">
                    <div className='pt-6'>
                        <img src={Logo} alt="" />
                    </div>
                    <div>
                        {preparing()}
                        {!isPreparing && currentQuestion &&
                            <>
                                <div className='grid gap-x-[16px] grid-cols-12 mt-28'>
                                    <div className='col-span-6 col-start-4'>
                                        <div className='flex'>
                                            <div className='grow'>
                                                <div className='rounded-[8px] bg-[#ffffff1a] w-fit p-[8px]'>
                                                    <img src={`${SERVER}public/icons-categories/${currentQuestion.categoria.icono}`} alt={currentQuestion.categoria.nombre} className="w-[32px]" />
                                                </div>
                                            </div>
                                            
                                            <div className='bonus-container'>
                                                <svg>
                                                    <circle r="21" cx="24" cy="24" ref={timerBonus} ></circle>
                                                </svg>
                                                <img src={ICON_BONUS} alt='' ref={iconBonus} />
                                            </div>
                                        </div>
                                        <p className='font-family-montserrat text-[#7CC8FF] text-[12px] mt-6 '>{currentQuestion.categoria.nombre}</p>
                                        <p className='text-white text-[20px] mt-3'>{currentQuestion.pregunta}</p>
                                    </div>
                                </div>

                                {
                                    currentQuestion.options.map((option, index) => (
                                        <div className='option-container' key={index} onClick={() => handleAnswer(index, option)}>
                                            <div className={'col-span-6 col-start-4 option-answer ' + (myAnswer ? (myAnswer.index === index ? 'selected' : 'disabled') : '')}>
                                                <div className='option'>{option.respuesta}</div>
                                            </div>
                                            <div className='col-span-3 option-result'>
                                                <div className='text-white font-bold text-[12px]'>
                                                    <p>{formatResponseTime()}</p>
                                                    <p>{myAnswer && myAnswer.extraPoints ? TranslateService.get('indivualChall.challenges.round.quickAnswer') + ' 💪': ''}</p>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }
                            </>
                        }


                    </div>
                </div>

                {myAnswer &&
                    <div className={'footer-question good ' + (myAnswer.esCorrecta ? 'good' : 'bad')}>
                        <div className='container mx-auto px-4'>
                            <div className='grid gap-x-[16px] grid-cols-12'>
                                <div className='col-span-6 col-start-4'>

                                    <div className={'points-container ' + (!myAnswer.esCorrecta ? '!hidden' : '')} >
                                        <p className='points'>+{myAnswer.points} PTS</p>
                                        
                                        {myAnswer.extraPoints && 
                                            <p className='points'>+{myAnswer.extraPoints} {TranslateService.get('indivualChall.challenges.round.quickAnswerBonus')} 💪</p>
                                        }
                                        
                                    </div>

                                    <div className='flex items-center'>
                                        <div className='grow mr-3'>
                                            <p className='heading-h5'>
                                            { myAnswer.esCorrecta?  TranslateService.get('indivualChall.challenges.round.right'): TranslateService.get('indivualChall.challenges.round.wrong')}
                                            </p>
                                            <p>{myAnswer.esCorrecta ? currentQuestion.feedbackCorrecto : currentQuestion.feedbackIncorrecto}</p>
                                        </div>
                                        <Button className={myAnswer.esCorrecta ? 'green' : 'red'} onClick={nextQuestion}>{TranslateService.get('indivualChall.challenges.round.next')}</Button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                }
            </div>
        </>
    )
}